import script from "./PolitiqueDeConfidentialite.vue?vue&type=script&setup=true&lang=js"
export * from "./PolitiqueDeConfidentialite.vue?vue&type=script&setup=true&lang=js"

import "./PolitiqueDeConfidentialite.vue?vue&type=style&index=0&id=451d1954&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451d1954"]])

export default __exports__